export default __webpack_public_path__ + "static/expand-business-e3b5ca46fd1b9923f1f60b6bcf27c32e.jpg";